const deliveryPopup = document.getElementById('delivery-option--popup');
const deliveryPopupOpener = document.getElementById('delivery-popup--opener');
const deliveryPopupOpenerMobile = document.getElementById('delivery-popup--opener-mobile');
const deliveryPopupClose = document.getElementById('delivery-popup--close');
const hederCloseIcon = document.querySelector('.header__icon--summary')
const deliveryPopupSection = document.querySelector('.delivery-option--popup    ');

function openDeliveryPopup() {
    deliveryPopup.classList.remove('hidden');
    deliveryPopupOpenerMobile.classList.remove('hidden'); 
    document.body.classList.add('overflow-hidden');
    deliveryPopupSection.style.display = 'block';
}

deliveryPopupOpener.addEventListener('click', openDeliveryPopup);
deliveryPopupOpenerMobile.addEventListener('click', ()=>{
    hederCloseIcon.click();
    openDeliveryPopup();
});

deliveryPopupClose.addEventListener('click',()=>{
    deliveryPopup.classList.add('hidden')
    document.body.classList.remove('overflow-hidden');
})